import { api } from "./api";
import drupalBaseEndpoint, { drupalBaseJsonApi } from "./base";
import { getApiLanguage } from "./i18n";

export const jsonApi = <T>(url: string) => api<T>(`${drupalBaseEndpoint}/${getApiLanguage()}/${drupalBaseJsonApi}/${url}`);
